import { JointPositions } from "../../types";
import { Joint } from "../joint";
import { Group } from "./group";

/**
 * Dummy group to enable blending of states for a set of joints
 */
export class DummyGroup extends Group {
  constructor(root: Joint) {
    super();
    const toVisit: Joint[] = [root];
    let current: Joint | undefined = undefined;

    while ((current = toVisit.pop())) {
      const joint = current;

      this.joints.push(joint);

      toVisit.push(...joint.childEdges.map((e) => e.end));
    }
  }

  solveForward(targets: JointPositions): boolean {
    return true;
  }

  solveBackward(targets: JointPositions): boolean {
    return true;
  }
}
